import { Checkbox, Input, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect, useState, useMemo } from "react";
import { ModalHeader } from "datastake-daf/dist/components";
import Footer from "../../../../../../../components/dashboards/components/project-visualisation/components/Footer";
import DashboardPopover from "../../../../../../../components/dashboards/components/Popover";
import Alert from "../../../../../../../components/dashboards/components/project-visualisation/components/Alert";
import { Link } from "react-router-dom";
import { useApp } from "../../../../../../../helpers/user";
import DafTable from "../../../../../../../components/Table/newTable";

const { Search } = Input;

export default function Settings({
  partners = [],
  settingsVisible,
  setSettingsVisible,
  setSelectedPartners,
  selectedParters = [],
}) {
  const app = useApp();
  const { t } = useTranslation();
  const [selectedRows, setSelectedRows] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    setSelectedRows(selectedParters);
  }, [selectedParters]);

  const onSearch = (_search) => {
    setSearch(_search);
    const _filteredPartners = partners.filter((p) => p.nickName.toLowerCase().indexOf(_search.toLowerCase()) !== -1);
    setSelectedRows(selectedRows.filter((id) => !!_filteredPartners.find((p) => p.id === id)));
  };

  const filteredParnters = useMemo(() => {
    if (search) {
      return partners.filter((p) => p.nickName.toLowerCase().indexOf(search.toLowerCase()) !== -1);
    }

    return partners;
  }, [search, partners]);

  const onSubmit = () => {
    setSelectedPartners(selectedRows);
    setSettingsVisible(false);
  };

  const columns = useMemo(() => {
    const isIntermediate = selectedRows.length && filteredParnters.length !== selectedRows.length;
    const isChecked = selectedRows.length && filteredParnters.length === selectedRows.length;

    return [
      {
        dataIndex: 'id',
        title: (
          <Checkbox
            indeterminate={isIntermediate}
            checked={isChecked}
            onChange={() => {
              if (isChecked) {
                setSelectedRows([]);
              } else {
                setSelectedRows(filteredParnters.map((p) => p.id));
              }
            }}
          />
        ),
        render: (val, all) => {
          if (all.empty) {
            return <div className="daf-default-cell" />;
          }

          const isChecked = selectedRows.includes(val);

          return (
            <div className="daf-default-cell">
              <Checkbox
                checked={isChecked}
                onChange={() => {
                  if (isChecked) {
                    setSelectedRows((prev) => [...prev.filter((p) => p !== val)]);
                  } else {
                    setSelectedRows((prev) => [...prev, val]);
                  }
                }}
              />
            </div>
          );
        },
        width: 40,
      },
      {
        dataIndex: 'nickName',
        title: t('Source'),
      },
    ]
  }, [t, selectedRows, filteredParnters]);

  return (
    <Modal
      open={settingsVisible}
      onCancel={() => setSettingsVisible(false)}
      footer={null}
      title={(
        <ModalHeader
          tooltip={{
            className: 'no-mb-title',
            title: (
              <DashboardPopover
                title={t('Sources Selection')}
                body={[
                  t('Select the available information sources you wish to feature on your analysis.'),
                  t('Go to the Partners section of your Settings to invite others.'),
                ]}
              />
            ),
          }}
          title={t('Sources Selection')}
        />
      )}
      width={630}
      className="custom-modal"
    >
      <Search
        className="mb-2"
        placeholder={t('Search')}
        onSearch={onSearch}
      />

      <div className="daf-table-wrapper flex-1 flex-c extra-small small-body">
        <DafTable
          doEmptyRows
          className="no-padding"
          size="small"
          columns={columns}
          data={filteredParnters}
          rowKey="id"
          scroll={{ y: 334 }}
          pagination={{ pageSize: 9 }}
        />
      </div>

      <div className="mt-3">
        <Alert
          message={
            <h5>
              {t('To add sources of information')}
              {', '}
              <Link to={`/app/${app}/partners`}>
                {t('invite a new partner.')}
              </Link>
            </h5>
          }
          localKey="parentInvitation"
        />
      </div>

      <Footer
        t={t}
        onSubmit={onSubmit}
        onClose={() => setSettingsVisible(false)}
      />
    </Modal>
  )
}
